import clsx from 'clsx';
import useI18n from '@i18n';

import ContainerWithLayout from '@components/pages/crypto/ContainerWithLayout';
import SectionTitle from '@components/pages/home/epnbz/Base/SectionTitle';
import ForWhomBlock from './ForWhomBlock';

import webmastersImg from './img/webmasters.png';
import arbitrageImg from './img/arbitrage.png';
import blogersImg from './img/blogers.png';
import socialImg from './img/social.png';

import styles from './ForWhom.module.scss';

const BlockForWhom: React.FC = () => {
    const { t } = useI18n('Crypto');
    return (
        <section className={styles.forWhom}>
            <ContainerWithLayout colorName="black">
                <div className={clsx(styles.landingContainer, styles.forWhom_content)}>
                    <div className={styles.forWhom_header}>
                        <SectionTitle classname={styles.forWhom_header_title} bigger>
                            {t('Who is this for?')}
                        </SectionTitle>
                    </div>
                    <div className={styles.forWhom_list}>
                        <ForWhomBlock
                            imgSrc={arbitrageImg}
                            text={t(
                                'Affiliate marketers who work with PPC (pay-per-click) and social media advertising',
                            )}
                        />
                        <ForWhomBlock
                            imgSrc={blogersImg}
                            text={t('Beginners and experienced bloggers and video bloggers')}
                        />
                        <ForWhomBlock
                            imgSrc={webmastersImg}
                            text={t(
                                'Website owners, owners of crypto publications, aggregators, etc.',
                            )}
                        />
                        <ForWhomBlock
                            imgSrc={socialImg}
                            text={t(
                                'Users and owners of social media groups and channels in messaging apps',
                            )}
                        />
                    </div>
                </div>
            </ContainerWithLayout>
        </section>
    );
};

export default BlockForWhom;
